/** Klassen zusammenfügen (falsy-Werte werden ignoriert). */
export const cn = (...classes: Array<string | false | null | undefined>) => classes.filter(Boolean).join(' ');
